<template>
	<div style="margin-bottom:100px;">

		<Editar :conclusao_tecnica="formData" :parent="this" :showForm="showFormEdit"/>

		<TableView
			registerName="Inserir Conclusão Técnica"
			:onRegister="(this.validarPermissao(573) ? onRegister : null)"  
			:onEdit="onEdit"
			:onDelete="onDelete"
			:onSearch="getConclusaoTecnica"
			:tableHead="tableHead"
			:tableData="tableData"
			:loadingTable="loadingTable"
			:pagination="pagination"
			:response="response"
		>
		</TableView>

	</div>
</template>

<script>
	
	import TableView from 'common/table'
	import Rest from 'common/rest'
	import Editar from './editar'

  	export default {
  		name:"exame",
  		components: {TableView,Editar},
  		mixins:[Rest],
  		data () {
		   	return {
		   		formData:{},
				pagination:{},
				response:{},
		   		tableHead:[
		   			{
		                key: 'id',
						sortable: true,
						label: 'CÓD',
		            },
		            {
		                key: 'nome',
						sortable: true,
						label: 'Nome',
		            },
		            {
		                key: 'descricao',
						show_colapse:true,
						label: 'Descrição',
					},
					{
		                key: 'ativo',
						label: 'Ativo',
		            }
		   		],
		   		tableData:[],
		   		loadingTable:false,
		   		showFormEdit:false,

			}
		},
		beforeDestroy(){
			this.tableData = [];
		},
		created(){
			
		},

		mounted: function() {
			this.getConclusaoTecnica();
		},	

		methods: {

			onRegister: function(){
				this.showFormEdit = !this.showFormEdit;
				this.formData = {
		   			id:0,
		   			nome:null,
		   			descricao:null,
		   			usuario:null,
		   			updated_at:null,
		   		};
			},

			onEdit: function(data){
				this.showFormEdit = !this.showFormEdit;
				this.formData = {
					id:data.id,
		   			nome:data.nome,
		   			descricao:data.descricao,
		   			usuario:data.usuario,
		   			updated_at:data.updated_at,
				};
			},

			onDelete: function(data){

				var self = this;

                this.$confirm('O sistema vai excluir '+data.length+' registro(s). Deseja prosseguir?', 'Atenção', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancelar',
                    type: 'warning'

                }).then(() => {

                    self.loadingTable = true;

                    this.post('/conclusao-tecnica/deletar',{ids:data}).then((result)=>{
                        result = result[0];

                        self.loadingTable = false;

                        if(result.status == 200){
                            self.getConclusaoTecnica();
                            self.edMsg('Registo excluido com sucesso');
                        }
                    });

                });
			},

			getConclusaoTecnica: function(_search,_page,_pagination){
				
				this.loadingTable = true;
				this.response = {};

				this.get('conclusao-tecnica',{search:_search,page:_page,pagination:_pagination}).then((result)=>{

		            result = result[0];
					this.response = result;

		             if(result.status == 200){

		             	var
		             		data = result.data.data,
		             		tableData = [],
		             		pagination = result.data

		             	for (var i = 0; i < data.length; i++) {

		             		var item = {
		             			'id': data[i].id,
		             			'nome': data[i].nome,
								'descricao': data[i].descricao,
								'ativo': (data[i].ativo == 1 ? 'Sim' : 'Não'),
		             			_data:data[i],
		             			options:{
									disable_delete:!this.validarPermissao(573),
									disable_edit:!this.validarPermissao(573),
								},
		             			buttons:[]
		             		};

		             		tableData.push(item);
		             	}

		             	this.pagination = pagination;
		             	this.tableData = tableData;
		             	this.loadingTable = false;
		             }
	            });
			},

		}
  	}
</script>


// WEBPACK FOOTER //
// index.vue?0cf3ce09